import { render, staticRenderFns } from "./ChuFangList.vue?vue&type=template&id=0deb9bfe&scoped=true"
import script from "./ChuFangList.vue?vue&type=script&lang=js"
export * from "./ChuFangList.vue?vue&type=script&lang=js"
import style0 from "./ChuFangList.vue?vue&type=style&index=0&id=0deb9bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deb9bfe",
  null
  
)

export default component.exports